import type { GetProjects200PageAllOfThreeContentItemUserInfoBasicInfo } from './getProjects200PageAllOfThreeContentItemUserInfoBasicInfo';
import type { GetProjects200PageAllOfThreeContentItemUserInfoSocial } from './getProjects200PageAllOfThreeContentItemUserInfoSocial';

/**
 * 간략한 사용자 정보
 */
export type GetProjects200PageAllOfThreeContentItemUserInfo = {
  /** 사용자 기본 정보 */
  basicInfo: GetProjects200PageAllOfThreeContentItemUserInfoBasicInfo;
  /** 소셜 관계 정보 */
  social?: GetProjects200PageAllOfThreeContentItemUserInfoSocial;
};
